import { type ImageDisturber } from '@ev-tech/search-modules-api';

export type BadgeSize = (typeof BadgeSize)[keyof typeof BadgeSize];
export const BadgeSize = {
  S: 'small',
  M: 'medium',
} as const;

export type BadgeVariant = ImageDisturber;
